import { ArrayHelpers, Help, SystemText } from '@salesperformanceint/e4shared';
import { ratingColour } from 'helpers/metrics';
import { translate } from 'helpers/translations';
import React from 'react';
import { useSelector } from 'react-redux';

export const CompetencyExtraData = ({ competency, id }) => {
    const { user } = useSelector(state => state.user);
    const reviewTypes = useSelector(state => state.user.user.reviewTypes) || [];
    return ArrayHelpers.existsAndHasLength(competency.extraData) ? (
        <Help id={`pi-help-${id}`} before>
            <div style={{ marginBottom: '-20px' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th className="">{SystemText('Dashboard/Widgets/General/CompetencyExtraData/Statement')}</th>
                            <th className="text-right no-wrap">
                                <i className="fa fa-user mr10" />
                            </th>
                            {reviewTypes.some(x => x.indexOf('M') >= 0) && (
                                <th className="text-right no-wrap">
                                    <i className="fa fa-user-tie-hair mr10" />
                                </th>
                            )}
                        </tr>
                    </thead>
                    <tbody>
                        {competency.extraData.map((x, y) => {
                            x.name = translate(user.language_Code, x, 'Statement', x.name);
                            return (
                                <tr key={`row-${id}-${y}`}>
                                    <td className="">
                                        <div className="">{x.name}</div>
                                    </td>
                                    <td className="text-right text-top">
                                        <label className={`label label-${ratingColour(x.value1)}`}>
                                            {x.value1.toFixed(1)}
                                        </label>
                                    </td>
                                    {reviewTypes.some(x => x.indexOf('M') >= 0) && (
                                        <td className="text-right text-top">
                                            <label className={`label label-${ratingColour(x.value2)}`}>
                                                {x.value2.toFixed(1)}
                                            </label>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                        <tr>
                            <td colSpan="3" style={{ borderBottom: '0' }} className="no-wrap text-sm text-center">
                                {SystemText('Dashboard/Widgets/General/CompetencyExtraData/Average')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </Help>
    ) : null;
};

export default CompetencyExtraData;
